// Simple mapping objects
export const NUMBER_TO_GRADE: Record<number, string> = {
  0: 'Kindergarten',
  1: 'Grade 1',
  2: 'Grade 2',
  3: 'Grade 3',
  4: 'Grade 4',
  5: 'Grade 5',
  6: 'Grade 6',
  7: 'Grade 7',
  8: 'Grade 8',
  9: 'Grade 9',
  10: 'Grade 10',
  11: 'Grade 11',
  12: 'Grade 12',
  255: 'Other',
};

export const GRADE_TO_NUMBER: Record<string, number> = Object.fromEntries(
  Object.entries(NUMBER_TO_GRADE).map(([number, grade]) => [grade, parseInt(number)]),
) as Record<string, number>;

export const SUBJECT_TO_ENUM: Record<string, string> = {
  Science: 'science',
  Art: 'art',
  Health: 'health',
  Language: 'language',
  Math: 'math',
  'Social Studies': 'social-studies',
  Geography: 'geography',
  Other: 'other',
};

export const ENUM_TO_SUBJECT: Record<string, string> = Object.fromEntries(
  Object.entries(SUBJECT_TO_ENUM).map(([subject, enumValue]) => [enumValue, subject]),
) as Record<string, string>;

export const GRADE_OPTIONS = Object.keys(GRADE_TO_NUMBER) as string[];

export const SUBJECT_OPTIONS = Object.keys(SUBJECT_TO_ENUM) as string[];
